import { STORE_NAME } from '@intigral/constant';
import { get, remove } from '@intigral/utils/lib/browser-storage/localStorage';
import { isInvalidPersistedUser } from './guards';

/** Runs on WCP entry before React bootstrap reads localStorage. */
function clearStaleUserOnLand(): void {
    if (typeof window === 'undefined') {
        return;
    }

    const stored = get(STORE_NAME.USER);

    if (isInvalidPersistedUser(stored)) {
        remove(STORE_NAME.USER);
    }
}

clearStaleUserOnLand();
